import React from 'react'
import { Link } from "react-router-dom";
import "./Filter.css";
import { TestData, CategoryData } from "../layout/TestData";
import { useState } from "react";
import { ShimmerTitle, ShimmerText } from "react-shimmer-effects";

export default function Filter({ 
  open, 
  setOpen,
  isDynamic = false,
  loading = false,
  categories = [],
  selectedCategories = [],
  onCategoryChange,
  attributes = [],
  selectedAttributeValues = [],
  onAttributeChange,
  onClearAll,
  // Doctor Filter Props
  isDoctorFilter = false,
  consultationTypes = [],
  selectedConsultationType = "",
  onConsultationTypeChange,
  specializations = [],
  selectedSpecialization = "",
  onSpecializationChange,
  languages = [],
  selectedLanguage = "",
  onLanguageChange,
  // New Day & City filters
  days = [],
  selectedDay = "",
  onDayChange,
  cities = [],
  selectedCity = "",
  onCityChange
}) {

    const [visible, setVisible] = useState(5);
    const [visiblesec, setVisiblesec] = useState(5);
    const [visibleSpecs, setVisibleSpecs] = useState(5);
    const [visibleLangs, setVisibleLangs] = useState(5);
    const [visibleDays, setVisibleDays] = useState(5);
    const [visibleCities, setVisibleCities] = useState(5);

    const handleClearAll = () => {
      if (onClearAll) {
        onClearAll();
      }
    };

  return (
    <> 
    
  
       <div className={`filter_sec_lab ${open ? "active" : ""}`}>
            <div className="cross_btn_filter">
                <button className="close_btn" onClick={() => setOpen(false)} >
                    ✕
                </button>
            </div> 
            <div className="filter_header_lab">
                <label className='text_20px'>Filters</label>   
                <p onClick={handleClearAll} style={{ cursor: 'pointer' }}>Clear All</p>
            </div>

            {isDoctorFilter ? (
              // DYNAMIC MODE FOR DOCTORS
              <div className="test_name_filter">
                <div className="accordion" id="accordionDoctor">
                  
                  {/* Consultation Type Filter */}
                  {consultationTypes && consultationTypes.length > 0 && (
                    <div className="accordion-item" style={{ borderBottom: "1px solid #DDDDDD" }}>
                      <span className="accordion-header">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseConsultation" aria-expanded="true" aria-controls="collapseConsultation">
                          Consultation Type
                        </button>
                      </span>
                      <div id="collapseConsultation" className="accordion-collapse collapse show">
                        <div className="accordion-body">
                          <ul className="test_list">
                            {consultationTypes.map((type) => (
                              <li key={type.consultation_type_id}>
                                <input 
                                  type="checkbox" 
                                  id={`ConsultType${type.consultation_type_id}`} 
                                  checked={String(selectedConsultationType) === String(type.consultation_type_id)}
                                  onChange={() => {
                                    if (String(selectedConsultationType) === String(type.consultation_type_id)) {
                                      onConsultationTypeChange && onConsultationTypeChange("");
                                    } else {
                                      onConsultationTypeChange && onConsultationTypeChange(type.consultation_type_id);
                                    }
                                  }}
                                />
                                <label htmlFor={`ConsultType${type.consultation_type_id}`}>
                                  {type.consultation_type_name}
                                </label>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Specialization Filter */}
                  {specializations && specializations.length > 0 && (
                    <div className="accordion-item" style={{ borderBottom: "1px solid #DDDDDD" }}>
                      <span className="accordion-header">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSpecialization" aria-expanded="true" aria-controls="collapseSpecialization">
                          Specialization
                        </button>
                      </span>
                      <div id="collapseSpecialization" className="accordion-collapse collapse show">
                        <div className="accordion-body">
                          <ul className="test_list">
                            {specializations.slice(0, visibleSpecs).map((spec) => (
                              <li key={spec.specialization_id}>
                                <input 
                                  type="checkbox" 
                                  id={`Specialization${spec.specialization_id}`} 
                                  checked={String(selectedSpecialization) === String(spec.specialization_id)}
                                  onChange={() => {
                                    if (String(selectedSpecialization) === String(spec.specialization_id)) {
                                      onSpecializationChange && onSpecializationChange("");
                                    } else {
                                      onSpecializationChange && onSpecializationChange(spec.specialization_id);
                                    }
                                  }}
                                />
                                <label htmlFor={`Specialization${spec.specialization_id}`}>
                                  {spec.specialization_name}
                                </label>
                              </li>
                            ))}
                            {specializations.length > 5 && (
                              <div className="show_less_more_btn">
                                {visibleSpecs < specializations.length ? (
                                  <button onClick={() => setVisibleSpecs(visibleSpecs + 5)}>
                                    Show More
                                  </button>
                                ) : (
                                  <button onClick={() => setVisibleSpecs(5)}>
                                    Show Less
                                  </button>
                                )}
                              </div>
                            )}
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Language Filter */}
                  {languages && languages.length > 0 && (
                    <div className="accordion-item" style={{ borderBottom: "1px solid #DDDDDD" }}>
                      <span className="accordion-header">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseLanguage" aria-expanded="true" aria-controls="collapseLanguage">
                          Language
                        </button>
                      </span>
                      <div id="collapseLanguage" className="accordion-collapse collapse show">
                        <div className="accordion-body">
                          <ul className="test_list">
                            {languages.slice(0, visibleLangs).map((lang) => (
                              <li key={lang.language_id}>
                                <input 
                                  type="checkbox" 
                                  id={`Language${lang.language_id}`} 
                                  checked={String(selectedLanguage) === String(lang.language_id)}
                                  onChange={() => {
                                    if (String(selectedLanguage) === String(lang.language_id)) {
                                      onLanguageChange && onLanguageChange("");
                                    } else {
                                      onLanguageChange && onLanguageChange(lang.language_id);
                                    }
                                  }}
                                />
                                <label htmlFor={`Language${lang.language_id}`}>
                                  {lang.language_name}
                                </label>
                              </li>
                            ))}
                            {languages.length > 5 && (
                              <div className="show_less_more_btn">
                                {visibleLangs < languages.length ? (
                                  <button onClick={() => setVisibleLangs(visibleLangs + 5)}>
                                    Show More
                                  </button>
                                ) : (
                                  <button onClick={() => setVisibleLangs(5)}>
                                    Show Less
                                  </button>
                                )}
                              </div>
                            )}
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Day Filter */}
                  {days && days.length > 0 && (
                    <div className="accordion-item" style={{ borderBottom: "1px solid #DDDDDD" }}>
                      <span className="accordion-header">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseDay" aria-expanded="false" aria-controls="collapseDay">
                          Filter by Day
                        </button>
                      </span>
                      <div id="collapseDay" className="accordion-collapse collapse">
                        <div className="accordion-body">
                          <ul className="test_list">
                            {days.slice(0, visibleDays).map((day) => (
                              <li key={day.day_id}>
                                <input 
                                  type="checkbox" 
                                  id={`Day${day.day_id}`} 
                                  checked={String(selectedDay) === String(day.day_id)}
                                  onChange={() => {
                                    if (String(selectedDay) === String(day.day_id)) {
                                      onDayChange && onDayChange("");
                                    } else {
                                      onDayChange && onDayChange(day.day_id);
                                    }
                                  }}
                                />
                                <label htmlFor={`Day${day.day_id}`}>
                                  {day.day_name}
                                </label>
                              </li>
                            ))}
                            {days.length > 5 && (
                              <div className="show_less_more_btn">
                                {visibleDays < days.length ? (
                                  <button onClick={() => setVisibleDays(visibleDays + 5)}>
                                    Show More
                                  </button>
                                ) : (
                                  <button onClick={() => setVisibleDays(5)}>
                                    Show Less
                                  </button>
                                )}
                              </div>
                            )}
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* City Filter */}
                  {cities && cities.length > 0 && (
                    <div className="accordion-item" style={{ borderBottom: "1px solid #DDDDDD" }}>
                      <span className="accordion-header">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseCity" aria-expanded="false" aria-controls="collapseCity">
                          Filter by City
                        </button>
                      </span>
                      <div id="collapseCity" className="accordion-collapse collapse">
                        <div className="accordion-body">
                          <ul className="test_list">
                            {cities.slice(0, visibleCities).map((city) => (
                              <li key={city.city_id}>
                                <input 
                                  type="checkbox" 
                                  id={`City${city.city_id}`} 
                                  checked={String(selectedCity) === String(city.city_id)}
                                  onChange={() => {
                                    if (String(selectedCity) === String(city.city_id)) {
                                      onCityChange && onCityChange("");
                                    } else {
                                      onCityChange && onCityChange(city.city_id);
                                    }
                                  }}
                                />
                                <label htmlFor={`City${city.city_id}`}>
                                  {city.city_name}
                                </label>
                              </li>
                            ))}
                            {cities.length > 5 && (
                              <div className="show_less_more_btn">
                                {visibleCities < cities.length ? (
                                  <button onClick={() => setVisibleCities(visibleCities + 5)}>
                                    Show More
                                  </button>
                                ) : (
                                  <button onClick={() => setVisibleCities(5)}>
                                    Show Less
                                  </button>
                                )}
                              </div>
                            )}
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}

                </div>
              </div>
            ) : isDynamic ? (
              // DYNAMIC MODE FOR MEDICAL EQUIPMENTS
              loading ? (
                <div className="p-3">
                  <ShimmerTitle line={1} variant="primary" className="mb-3" />
                  <ShimmerText line={5} gap={15} className="mb-4" />
                  <ShimmerTitle line={1} variant="primary" className="mb-3" />
                  <ShimmerText line={4} gap={15} />
                </div>
              ) : (
                <div className="test_name_filter">
                  <div className="accordion" id="accordionExample">
                    
                    {/* Category Filter */}
                    {categories && categories.length > 0 && (
                      <div className="accordion-item" style={{ borderBottom: "1px solid #DDDDDD" }}>
                        <span className="accordion-header">
                          <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseCategory" aria-expanded="true" aria-controls="collapseCategory">
                            Category
                          </button>
                        </span>
                        <div id="collapseCategory" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                          <div className="accordion-body">
                            <ul className="test_list">
                              {categories.slice(0, visiblesec).map((cat) => (
                                <li key={cat.mec_id}>
                                  <input 
                                    type="checkbox" 
                                    id={`Category${cat.mec_id}`} 
                                    checked={selectedCategories.includes(String(cat.mec_id))}
                                    onChange={() => onCategoryChange && onCategoryChange(cat.mec_id)}
                                  />
                                  <label htmlFor={`Category${cat.mec_id}`}>
                                    {cat.mec_name}
                                  </label>
                                </li>
                              ))}
                              {categories.length > 5 && (
                                <div className="show_less_more_btn">
                                  {visiblesec < categories.length ? (
                                    <button onClick={() => setVisiblesec(visiblesec + 5)}>
                                      Show More
                                    </button>
                                  ) : (
                                    <button onClick={() => setVisiblesec(5)}>
                                      Show Less
                                    </button>
                                  )}
                                </div>
                              )}
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Attribute Filters */}
                    {attributes && attributes.map((attr, idx) => {
                      // Only render attribute if it has values
                      if (!attr.values || attr.values.length === 0) return null;
                      
                      return (
                        <div className="accordion-item" key={attr.attribute_id} style={{ borderBottom: "1px solid #DDDDDD" }}>
                          <span className="accordion-header">
                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseAttr${idx}`} aria-expanded="true" aria-controls={`collapseAttr${idx}`}>
                              {attr.attribute_name}
                            </button>
                          </span>
                          <div id={`collapseAttr${idx}`} className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                              <ul className="test_list">
                                {attr.values.map((val) => (
                                  <li key={val.id}>
                                    <input 
                                      type="checkbox" 
                                      id={`AttrVal${val.id}`} 
                                      checked={selectedAttributeValues.includes(Number(val.id))}
                                      onChange={() => onAttributeChange && onAttributeChange(val.id)}
                                    />
                                    <label htmlFor={`AttrVal${val.id}`}>
                                      {val.name}
                                    </label>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </div>
                      );
                    })}

                  </div>
                </div>
              )
            ) : (
              // STATIC COMPATIBILITY MODE
              <>
                <div className="test_name_filter">
                    <div className="accordion" id="accordionExample">
                        <div className="accordion-item">
                            <span className="accordion-header">
                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                Must Have Tests
                            </button>
                            </span>
                            <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    <ul className="test_list">
                                        {TestData.slice(0, visible).map((test) => (
                                            <li key={test.id}>
                                                <input type="checkbox" id={`test${test.id}`} />
                                                <label htmlFor={`test${test.id}`}>
                                                   {test.testname}
                                                </label>
                                            </li>
                                        ))}

                                        <div className="show_less_more_btn">
                                            {visible < TestData.length ? (
                                                <button onClick={() => setVisible(visible + 5)}>
                                                    Show More
                                                </button>
                                                ) : (
                                                <button onClick={() => setVisible(5)}>
                                                    Show Less
                                                </button>
                                                )}
                                        </div>
                                    </ul>                                           
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="category_name_filter test_name_filter">
                    <div className="accordion" id="accordionExample">
                        <div className="accordion-item">
                            <span className="accordion-header">
                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapsetwo" aria-expanded="true" aria-controls="collapsetwo">
                                Category
                            </button>
                            </span>
                            <div id="collapsetwo" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    <ul className="test_list">
                                        {CategoryData.slice(0, visiblesec).map((Category) => (
                                            <li key={Category.id}>
                                                <input type="checkbox" id={`Category${Category.id}`} />
                                                <label htmlFor={`Category${Category.id}`}>
                                                    {Category.Categoryname}
                                                </label>
                                            </li>
                                        ))}
                                        <div className="show_less_more_btn">
                                            {visiblesec < TestData.length ? (
                                                <button onClick={() => setVisiblesec(visiblesec + 5)}>
                                                    Show More
                                                </button>
                                                ) : (
                                                <button onClick={() => setVisiblesec(5)}>
                                                    Show Less
                                                </button>
                                            )}
                                        </div>
                                    </ul>                                           
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </>
            )}
        </div>
                    
 
    </>
  )
}
